<script setup lang="ts">
import ListItem from '@/core/ListItem.vue';
import { toRefs } from 'vue';

const emit = defineEmits<{
  click: [];
}>();

const props = defineProps<{
  disabled?: boolean;
}>();
const { disabled } = toRefs(props);

const handleClick = (): void => {
  if (disabled.value) return;
  emit('click');
};
</script>

<template>
  <ListItem
    class="outline-inner"
    :class="[disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer']"
    :tabindex="disabled ? -1 : 0"
    @keydown.space.prevent="handleClick"
    @keydown.enter.prevent="handleClick"
    @click="handleClick"
  >
    <slot></slot>
  </ListItem>
</template>
